import React from "react";
import moment from 'moment';
import {
    Link,
    Redirect
} from "react-router-dom";
import {
    getData
} from '../../../services/index';
import {
    Collapse,
    Radio,
    Checkbox,
    label,
    Input,
    Popover,
    Button,
    Tooltip,
    TimePicker,
    Select,
    DatePicker,
    Upload,
    Modal,
    message
} from 'antd';
import {
    LoadingOutlined,
    PlusOutlined
} from '@ant-design/icons';
const buttonWidth = 70;
const {
    TextArea
} = Input;

function callback(key) {
    console.log(key);
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function getBase64_(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
}
class Index extends React.Component {
        static contextTypes = {
            router: () => null
        };
        constructor(props) {
            super(props);
            this.state = {
                size: 'default',
                previewVisible: false,
                previewImage: '',
                previewTitle: '',
                imageUrl: '',
                fileList: [],
                bus_list: [],
                division_list: [],
                pickup_route_list: [],
                drop_route_list: [],
                pickup_stop_list: [],
                drop_stop_list: [],
                program_list: [],
                student_list: [],
                academic_year_: [],
                student: [],
                loading: false,
                name: '',
                pickup_time: '',
                drop_time: '',
                mobile: '',
                licence: '',
                loading: false,
                iconLoading: false,
            }
            this.change_year = this.change_year.bind(this);
            this.change_pickup_bus = this.change_pickup_bus.bind(this);
            this.change_pickup_route = this.change_pickup_route.bind(this);
            this.change_pickup_stop = this.change_pickup_stop.bind(this);
            this.change_drop_bus = this.change_drop_bus.bind(this);
            this.change_drop_route = this.change_drop_route.bind(this);
            this.change_drop_stop = this.change_drop_stop.bind(this);
            this.change_program = this.change_program.bind(this);
            this.change_student = this.change_student.bind(this);
			
			this.change_division = this.change_division.bind(this);	
        }
        componentWillMount() {
            document.querySelector(".loader-wrapper").style = "display: none";
            setTimeout(() => {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 500);
            if (!localStorage.getItem('schoolData')) {
                localStorage.setItem("schoolData", '');
                localStorage.clear();
                window.location.href = '/login';
            } else {
                var storedArray = JSON.parse(localStorage.getItem("schoolData"))
                this.setState({
                    user_id: storedArray['data'][0]['user_id'],
                    school_id: storedArray['data'][0]['school_id']
                });
            }
            this.checkData();
        }
        checkData() {
            if (localStorage.getItem('schoolData')) {
                var storedArray = JSON.parse(localStorage.getItem("schoolData"));
                var user_id = storedArray['data'][0]['user_id'];
                var school_id = storedArray['data'][0]['school_id'];
                var app = {
                    school_id: school_id,
                    user_id: user_id
                }
                getData('Transport/bus_list', app).then((result) => {
                    let responseJson = result;
                    if (responseJson.data) {
                        if (result['status'] == 200) {
                            this.setState({
                                bus_list: result['data'],
                            });
                        } else {
                            this.setState({
                                bus_list: [],
                            });
                        }
                    }
                });

                getData('erp/program_list', app).then((result) => {
                    let responseJson = result;
                    if (responseJson.data) {
                        if (result['status'] == 200) {
                            this.setState({
                                program_list: result['data'],
                            });
                        } else {
                            this.setState({
                                program_list: [],
                            });
                        }
                    }
                });

                getData('Transport/academic_year_list', app).then((result) => {
                    let responseJson = result;
                    if (responseJson.data) {
                        if (result['status'] == 200) {
                            this.setState({
                                academic_year_: result['data'],
                            });
                        } else {
                            this.setState({
                                academic_year_: [],
                            });
                        }
                    }
                });

            }
        }
        handleSubmit = (e) => {
            e.preventDefault();
            if (localStorage.getItem('schoolData')) {
                this.setState({
                    loading: true
                });
                var app = {
                    user_id: this.state.user_id,
                    school_id: this.state.school_id,
                    academic_year: this.state.academic_year,
                    drop_id: this.state.drop_id,
                    pickup_id: this.state.pickup_id,
                    program: this.state.program,
                    division: this.state.division,
                    student: this.state.student,
                }
                getData('Transport/add_student_to_transport', app).then((result) => {
                    if (result.status == 400) {
                        message.config({
                            top: 150
                        });
                        message.error(result.error_msg, 2);
                        if (result.error_name == '') {
                            document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
                        } else {
                            if (result.error_name != '') {
                                document.getElementsByName(result.error_name)[0].classList.add("error_focus");
                            }
                        }
                        this.setState({
                            loading: false
                        });
                    } else if (result.status == 200) {
                        message.config({
                            top: 150
                        });
                        message.success('Student Assign Successfull !!', 2);
                        this.setState({
                            loading: false
                        });
                        this.setState({
                            comment_text: ''
                        });
                        window.location.href = '/transport-setup/manage-student';
                    } else {
                        this.setState({
                            loading: false
                        });
                    }
                });
            } else {
                message.error('Please Login', 2);
                this.setState({
                    loading: false
                });
            }
        }
        handleSizeChange = e => {
            this.setState({
                [e.target.name]: e.target.value
            });
            if (e.target.name) {
                document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
            }
        };
        change_year(event) {
            this.setState({
                academic_year: event
            });
            document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
        }

        change_pickup_bus(event) {
            this.setState({
                pickup_bus: event,
                pickup_route: '',
                pickup_stop: '',
                pickup_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[1].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event
            }
            getData('Transport/route_list_by_bus', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            pickup_route_list: result['data'],
                        });
                    } else {
                        this.setState({
                            pickup_route_list: [],
                        });
                    }
                }
            });
        }
        change_pickup_route(event) {
            this.setState({
                pickup_route: event,
                pickup_stop: '',
                pickup_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[2].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event
            }
            getData('Transport/stop_list_by_route', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            pickup_stop_list: result['data'],
                        });
                    } else {
                        this.setState({
                            pickup_stop_list: [],
                        });
                    }
                }
            });
        }
        change_pickup_stop(event) {
            this.setState({
                pickup_stop: event,
                pickup_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[3].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event,
            }
            getData('Transport/timing_list_by_stop', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            pickup_timing_list: result['data'],
                            pickup_time: result['data'][0]['pickup_time'],
                            pickup_id: result['data'][0]['id'],
                        });
                    } else {
                        this.setState({
                            pickup_timing_list: [],
                        });
                    }
                }
            });
        }
        change_drop_bus(event) {
            this.setState({
                drop_bus: event,
                drop_route: '',
                drop_stop: '',
                drop_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[4].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event
            }
            getData('Transport/route_list_by_bus', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            drop_route_list: result['data'],
                        });
                    } else {
                        this.setState({
                            drop_route_list: [],
                        });
                    }
                }
            });
        }
        change_drop_route(event) {
            this.setState({
                drop_route: event,
                drop_stop: '',
                drop_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[5].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event
            }
            getData('Transport/stop_list_by_route', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            drop_stop_list: result['data'],
                        });
                    } else {
                        this.setState({
                            drop_stop_list: [],
                        });
                    }
                }
            });
        }
        change_drop_stop(event) {
            this.setState({
                drop_stop: event,
                drop_time: ''
            });
            document.getElementsByClassName('ant-select-selection')[6].classList.remove("error_focus");
            var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                id: event
            }
            getData('Transport/timing_list_by_stop', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            drop_timing_list: result['data'],
                            drop_time: result['data'][0]['drop_time'],
                            drop_id: result['data'][0]['id'],
                        });
                    } else {
                        this.setState({
                            drop_timing_list: [],
                        });
                    }
                }
            });
        }
        change_program(event) {
			this.setState({
                program: event,
                student: [],
				division_list: [],
				division: '',
            });
            document.getElementsByClassName('ant-select-selection')[7].classList.remove("error_focus");
			var app = {user_id : this.state.user_id,program_id:event,school_id:this.state.school_id}
			getData('erp/division_list_by_class',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							division_list: result['data'],
						});
					}else{
						this.setState({
							division_list: [],
						});
					}
				}
			});	
            
        }
		
		change_division(event){
			this.setState({division: event});
			var app = {
                school_id: this.state.school_id,
                user_id: this.state.user_id,
                program: this.state.program,
                division: event,
                academic_year: this.state.academic_year,
                drop_id: this.state.drop_id,
                pickup_id: this.state.pickup_id,
            }
            getData('Transport/student_list_by_program', app).then((result) => {
                let responseJson = result;
                if (responseJson.data) {
                    if (result['status'] == 200) {
                        this.setState({
                            student_list: result['data'],
                        });
                    } else {
                        this.setState({
                            student_list: [],
                        });
                    }
                }
            });
		}

        change_student(event) {
            this.setState({
                student: event
            });
            document.getElementsByClassName('ant-select-selection')[8].classList.remove("error_focus");
        }
	
render()
{
const { previewVisible, previewImage, fileList, previewTitle } = this.state;
const uploadButton = (
<div>
   <div className="ant-upload-text">Upload</div>
</div>
);
const uploadButton1 = (
<div>
   {this.state.loading ? 
   <LoadingOutlined />
   : 
   <PlusOutlined />
   }
   <div className="ant-upload-text">Upload Profile</div>
</div>
);
const { imageUrl } = this.state;
return (
<div class="mobile_view">
   <div class="row bred">
		<div class="col-md-12">
			<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Manage Student
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/manage-student`} class="router-link-active" target="_self">Assign Student</a></li>
								<li class="breadcrumb-item"> Add Manage Student</li>
							</ol>
						</div>
					</h4>
				</div>
			</div>
		</div>
	</div>
   <div id="main" class="bg-off">
      <div class="row">
              <div class="col-md-12 ex-padd">
            
            <div class="view-Profile child-profile view-Profile-mobile">
			
			   <div class="col-md-12 mt-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
                     <div class="children mb-20 iq-card2 flow-root form-group">
                        <div class="row">
                           <div class="col-md-4 mb-10">
							  <label>Academic Year</label>
								<Select onChange={this.change_year}>
									{this.state.academic_year_.map((list) => (
										<Select.Option value={list.name}>{list.name}</Select.Option>
									))}
								</Select>
                           </div>
						    <div class="col-md-4 mb-10">
                              <label>Select Program *</label>
                              <Select onChange={this.change_program} > 
                                 {this.state.program_list.map((list)=> ( 
                                 <Select.Option value={list.id}>{list.name}</Select.Option>
                                 ))}
                              </Select>
                           </div>
						    <div class="col-md-4 mb-10">
                              <label>Select Division *</label>
                              <Select onChange={this.change_division} value={this.state.division}> 
                                 {this.state.division_list.map((list)=> ( 
                                 <Select.Option value={list.id}>{list.name}</Select.Option>
                                 ))}
                              </Select>
                           </div>
                        <div class="col-md-6">
                           <div class="trans-border ">
                              <h6 class="center"><b>Pickup</b></h6>
							  
                              <div class="row">
                              <div class="col-md-4 mb-10 ">
                                 <label>Select Bus</label>
                                 <Select onChange={this.change_pickup_bus} > 
                                    {this.state.bus_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.bus_name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-4 mb-10">
                                 <label>Select Route</label>
                                 <Select onChange={this.change_pickup_route} value={this.state.pickup_route} > 
                                    {this.state.pickup_route_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-4 mb-10">
                                 <label>Select Stop</label>
                                 <Select onChange={this.change_pickup_stop} value={this.state.pickup_stop} > 
                                    {this.state.pickup_stop_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-6 mb-20 mt-20 pt-20 mob-mt-0">
                                 <label><b>Estimated Pickup Time: {this.state.pickup_time}</b></label>
                              </div>
                              </div>
							  
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="trans-border">
                              <h6 class="center"><b>Drop</b></h6>
							  <div class="row">
                              <div class="col-md-4 mb-10">
                                 <label>Select Bus</label>
                                 <Select onChange={this.change_drop_bus} > 
                                    {this.state.bus_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.bus_name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-4 mb-10">
                                 <label>Select Route</label>
                                 <Select onChange={this.change_drop_route} value={this.state.drop_route} > 
                                    {this.state.drop_route_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-4 mb-10">
                                 <label>Select Stop</label>
                                 <Select onChange={this.change_drop_stop} value={this.state.drop_stop} > 
                                    {this.state.drop_stop_list.map((list)=> ( 
                                    <Select.Option value={list.id}>{list.name}</Select.Option>
                                    ))}
                                 </Select>
                              </div>
                              <div class="col-md-6 mb-20 mt-20 pt-20 mob-mt-0">
                                 <label><b>Estimated Drop Time: {this.state.drop_time}</b></label>
                              </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-md-12  pl-0">
                          
                           <div class="col-md-12 mb-20 mb-10 multiple">
                              <label>Select Student *</label>
                              <Select onChange={this.change_student} value={this.state.student} mode="multiple" > 
                                 {this.state.student_list.map((list)=> ( 
                                 <Select.Option value={list.id}>{list.name}</Select.Option>
                                 ))}
                              </Select>
                           </div>
                        </div>
                     </div>
                     </div>
                     <div class="col-md-12 meal mt-20 mb-20 pt-20 bt center">
                        <Button className="ant-btn btn  btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
                     </div>
                  </section>
               </div>
               </div>
               </div>
               <div class="content-overlay"></div>
      </div>
   </div>
</div>
) 
} 
}
export default Index;